<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch4">
<div class="chapterHead"><p class="centerImage3"><img alt="image" src="images/ch4.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;">Standing in the doorway are the vampires. All of them!</p>
<p class="para" style="text-indent: 5%;">Countess Yvonne stalks toward you. Right behind her are at least twenty others. Hungry for blood!</p>
<p class="para" style="text-indent: 5%;">“Don’t be afraid,” Countess Yvonne says. “We only want to drain the rest of your fresh, human blood. Then you’ll truly be one of us. Don’t worry. It won’t hurt.”</p>
<p class="para" style="text-indent: 5%;">The last person who told you that was your dentist.</p>
<p class="para" style="text-indent: 5%;">“Run!” you shout at Gabe.</p>
<p class="para" style="text-indent: 5%;">But you can’t run. The vampires are pushing into the small room, filling the doorway.</p>
<p class="para" style="text-indent: 5%;">You feel like you’re losing your mind. You cry, “I’m going batty!”</p>
<p class="para" style="text-indent: 5%;">The countess stops in her tracks and starts laughing. “ ‘Batty’! What a hoot!” The other vampires begin laughing uncontrollably. The corny pun has them in hysterics!</p>
<p class="para" style="text-indent: 5%;">The bloodsuckers are distracted. Here’s your chance! You drop to your hands and knees and start crawling. Gabe follows you. You scramble like mad between the legs of the guffawing vampires.</p>
<p class="para" style="text-indent: 5%;">Quick, make a decision. Which way now?</p>
<p class="extractLetterText" style="text-indent: 5%;"><em class="italic">If you run back the way you came, turn to <span href="#/e9780545820660_ch018" title="Link target outside of Sample">PAGE 18</span>.</em></p>
<p class="para" style="text-indent: 5%;"><em class="italic">If you try to find the Garlic Spray, turn to <span href="#/e9780545820660_ch056" title="Link target outside of Sample">PAGE 56</span>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545820660_ch004.vue?20097146